// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1748":"bb70b004","7184":"4e2dcd74"}[chunkId] || chunkId) + "." + {"1748":"dda321ba53109991","7184":"a035f1ef46029767","8866":"d89ff89500da9ca5"}[chunkId] + ".js";
};